import React from "react";
import ShortcutMenuWrapper from "../ShortcutMenuWrapper";
import SealColorMenuIcon from "assets/menus/master-maintenance/is-seal-colors.png";
import ReportingMenuIcon from "assets/menus/master-maintenance/business-intelligence-management-1.svg";
import { useSelector } from "react-redux";
import { RootState } from "@app/store/store";
import { canAccess } from "@app/utils/permissionUtils";

export const CommissionMenu: React.FC = () => {
    const state = useSelector((state: RootState) => state);

    return (
        <ShortcutMenuWrapper
            title="shortcutMenus.commissionManagement.title"
            icon={ReportingMenuIcon}
            menus={[
                {
                    title: 'Commission Plans',
                    icon: SealColorMenuIcon,
                    url: '/commission-plans',
                    categoryIcon: ReportingMenuIcon,
                    show: canAccess(state, 'admin.manage.commission-plans')
                },
                {
                    title: 'Commission Payouts',
                    icon: SealColorMenuIcon,
                    url: '/commission-payouts',
                    categoryIcon: ReportingMenuIcon,
                    show: canAccess(state, 'admin.manage.commission-payouts') 
                },
                
            ]}
        />
    );
}